var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Bitmovin = youbora.StandardAdapter.extend({
    getVersion: function () {
        return manifest.version + '-' + manifest.name + '-' + manifest.tech
    },

    getPlayhead: function () {
        return this.playingAds ? this.lastPlayhead : this.player.getCurrentTime()
    },

    getDuration: function () {
        return this.player.getDuration()
    },

    getPlayrate: function () {
        if (this.flags.isPaused) return 0
        if (typeof this.player.getPlaybackSpeed() !== "undefined") {
            return this.player.getPlaybackSpeed()
        }
        return 1
    },

    getDroppedFrames: function () {
        return this.player.getDroppedFrames()
    },

    getBitrate: function () {
        if (this.player.getPlaybackVideoData && this.player.getPlaybackVideoData() &&
            this.player.getPlaybackVideoData().bitrate) {
            return this.player.getPlaybackVideoData().bitrate
        } else {
            return -1
        }
    },

    getRendition: function () {
        if (this.player.getPlaybackVideoData && this.player.getPlaybackVideoData()) {
            var playbackValues = this.player.getPlaybackVideoData()
            if (playbackValues.bitrate) {
                if (playbackValues.width && playbackValues.height) {
                    return youbora.Util.buildRenditionString(playbackValues.width, playbackValues.height, playbackValues.bitrate)
                }
                return playbackValues.bitrate
            }
            return this.player.getPlaybackVideoData().id
        }
        return -1;
    },

    getIsLive: function () {
        return this.player.isLive()
    },

    getResource: function () {
        if (this.player.getConfig) {
            var sourceObject = this.player.getConfig().source
            if (sourceObject) {
                return sourceObject.dash || sourceObject.hls || sourceObject.progressive
            }
        }
        return 'unknown'
    },

    getPlayerName: function () {
        return "Bitmovin"
    },

    getPlayerVersion: function () {
        return bitmovin.player.version
    },

    initializeAdapter: function () {
        this.monitorPlayhead(true, true)
    },

    getListenersList: function () {
        var EVENT = this.player.EVENT || bitmovin.player.EVENT
        var eventList = {}
        eventList[EVENT.ON_DOWNLOAD_FINISHED] = null
        eventList[EVENT.ON_DVR_WINDOW_EXCEEDED] = null
        eventList[EVENT.ON_ERROR] = this.errorListener
        eventList[EVENT.ON_FULLSCREEN_ENTER] = null
        eventList[EVENT.ON_FULLSCREEN_EXIT] = null
        eventList[EVENT.ON_HIDE_CONTROLS] = null
        eventList[EVENT.ON_METADATA] = null
        eventList[EVENT.ON_PAUSED] = this.pauseListener
        eventList[EVENT.ON_PLAY] = this.playListener
        eventList[EVENT.ON_PLAYING] = this.playingListener
        eventList[EVENT.ON_PLAYBACK_FINISHED] = this.endedListener
        eventList[EVENT.ON_PLAYER_CREATED] = null
        eventList[EVENT.ON_PLAYER_RESIZE] = null
        eventList[EVENT.ON_READY] = null
        eventList[EVENT.ON_SEEK] = this.seekingListener
        eventList[EVENT.ON_SEEKED] = this.seekedListener
        eventList[EVENT.ON_SEGMENT_PLAYBACK] = this.joinListener
        eventList[EVENT.ON_SEGMENT_REQUEST_FINISHED] = null
        eventList[EVENT.ON_SOURCE_LOADED] = null
        eventList[EVENT.ON_SOURCE_UNLOADED] = this.endedListener
        eventList[EVENT.ON_STALL_ENDED] = null
        eventList[EVENT.ON_STALL_STARTED] = null
        eventList[EVENT.ON_STOP_BUFFERING] = this.joinListener
        eventList[EVENT.ON_TIME_CHANGED] = this.joinChangedListener
        eventList[EVENT.ON_TIME_SHIFT] = null
        eventList[EVENT.ON_TIME_SHIFTED] = null
        eventList[EVENT.ON_VIDEO_ADAPTATION] = null
        eventList[EVENT.ON_VIDEO_DOWNLOAD_QUALITY_CHANGE] = null
        eventList[EVENT.ON_VIDEO_DOWNLOAD_QUALITY_CHANGED] = null
        eventList[EVENT.ON_VIDEO_PLAYBACK_QUALITY_CHANGED] = null
        eventList[EVENT.ON_VR_ERROR] = null
        eventList[EVENT.ON_VR_MODE_CHANGED] = null
        eventList[EVENT.ON_WARNING] = null
        eventList[EVENT.ON_SEGMENT_PLAYBACK] = null
        eventList[EVENT.ON_STALL_ENDED] = null
        eventList[EVENT.ON_STALL_STARTED] = null
        eventList[EVENT.ON_AD_BREAK_FINISHED] = this.endAdsListener
        eventList[EVENT.ON_AD_BREAK_STARTED] = this.startAdsListener
        return [{
            suscriber: 'addEventHandler',
            unsuscriber: 'removeEventHandler',
            events: eventList
        }]
    },

    /** Listener for 'ON_PLAY' event. */
    playListener: function (e) {
        if (!this.plugin.getAdsAdapter()) this.plugin.setAdsAdapter(new youbora.adapters.Bitmovin.NativeAdsAdapter(this.player))
        this.fireStart()
        this.fireResume()
    },

    /** Listener for 'ON_SEGMENT_PLAYBACK' and 'ON_STOP_BUFFERING' events. */
    joinListener: function (e) {
        this.fireJoin()
    },

    /** Listener for 'ON_PAUSED' event. */
    pauseListener: function (e) {
        if (!this.flags.isSeeking) this.firePause()
    },

    /** Listener for 'ON_PLAYING' events. */
    playingListener: function (e) {
        this.fireStart()
    },

    /** Listener for 'ON_ERROR' event. */
    errorListener: function (e) {
        this.fireError(e.code, e.message)
        // 200, 303, 403, 404, 405, 900, 901 Advertisement
        // 1000 to 1028 Setup error
        // 2000, 2001, 2002, 3000 to 3047 Error
        // 5000 to 5013 Warning
        if (e.code >= 1000 && e.code <= 4999) {
            this.fireStop()
        }
    },

    /** Listener for 'ON_SEEK' event. */
    seekingListener: function (e) {
        this.fireSeekBegin()
    },

    /** Listener for 'ON_SEEKED' event. */
    seekedListener: function (e) {
        this.monitor.skipNextTick()
    },

    /** Listener for 'ON_PLAYBACK_FINISHED' event. */
    endedListener: function (e) {
        this.fireStop()
    },

    /** Listener for 'ON_TIME_CHANGED' event*/
    joinChangedListener: function (e) {
        if (this.getPlayhead() > 0) {
            this.fireStart()
            this.fireJoin()
        }
        this.lastPlayhead = this.getPlayhead()
    },

    /** Listener for 'ON_AD_BREAK_FINISHED' event*/
    endAdsListener: function (e) {
        this.playingAds = false
        this.fireResume()
    },

    /** Listener for 'ON_AD_BREAK_STARTED' event*/
    startAdsListener: function (e) {
        this.playingAds = true
        this.firePause()
    }
},
    // Static members
    {
        NativeAdsAdapter: require('./ads/nativeads'),
    }
)

module.exports = youbora.adapters.Bitmovin
